import { IApiContentModelBase, NieuwbouwDetailPaginaContentModel, ProjectenDetailPaginaContentModel } from '@woonstad/api-client-content-delivery';

export const SITES = {
  Stadswonen: 'stadswonen-website',
  Woonstad:  'woonstad-website'
} as const;

export type SitesType = typeof SITES[keyof typeof SITES];

export type NewsFilters = {
    types: string[];
    tags: string[];
};

export type ProjectenDetailPaginaContentModelWithParent = ProjectenDetailPaginaContentModel & {
  parents?: {
    items?: IApiContentModelBase[];
    total: number;
  };
};

export type NieuwbouwDetailPaginaContentModelWithParent = NieuwbouwDetailPaginaContentModel & {
  parents?: {
    items?: IApiContentModelBase[];
    total: number;
  };
};
